var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-hoverable buttons"},[_c('hr'),_vm._l((_vm.answers),function(answer,index){return _c('a',{key:index,staticClass:"lb-answer",class:{
            'is-success': _vm.isAnsweredRight(answer),
            'is-danger': _vm.isAnsweredWrong(answer),
        },on:{"click":function($event){return _vm.selectAnswer(answer)}}},[_vm._v("\n        "+_vm._s(answer.value)+"\n    ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }